import script from "./BotaoTema.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoTema.vue?vue&type=script&setup=true&lang=js"

import "./BotaoTema.vue?vue&type=style&index=0&id=c7e0e706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e0e706"]])

export default __exports__